module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/artefato/instalacao-produto/instalacao-produto.component.css
// module id = ./src/app/artefato/instalacao-produto/instalacao-produto.component.css
// module chunks = main